import { useEffect } from "react";
import sucImg from "../redes/sucursales.jpg";

const SucursalModal = ({ sucursal, onClose }) => {
  useEffect(() => {
    if (!sucursal) return;
    document.body.style.overflow = "hidden";
    return () => { document.body.style.overflow = "auto"; };
  }, [sucursal]);

  if (!sucursal) return null;

  const infoItems = [
    { icon: "📍", label: "Dirección", value: sucursal.direccion },
    { icon: "📞", label: "Teléfono",  value: sucursal.telefono  },
    { icon: "⏰", label: "Horario",   value: sucursal.horario   },
  ];

  return (
    <div style={s.overlay} onClick={onClose}>
      <div style={s.card} onClick={e => e.stopPropagation()}>

        {/* Cerrar */}
        <button style={s.closeBtn} onClick={onClose} aria-label="Cerrar">×</button>

        {/* Media */}
        <div style={s.media}>
          {sucursal.imagen_maps ? (
            <iframe
              src={sucursal.imagen_maps}
              style={{ width: "100%", height: "100%", border: 0, display: "block" }}
              allowFullScreen loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title={`Mapa de ${sucursal.nombre}`}
            />
          ) : (
            <img
              src={sucursal.imagen
                ? `${process.env.REACT_APP_URL_BACKEND}${sucursal.imagen}`
                : sucImg}
              alt={`Foto de ${sucursal.nombre}`}
              style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
              loading="lazy"
            />
          )}
        </div>

        {/* Cuerpo */}
        <div style={s.body}>
          {/* Chip tipo */}
          <span style={s.chip}>Sucursal</span>

          <h3 style={s.title}>{sucursal.nombre}</h3>

          <div style={s.infoGrid}>
            {infoItems.map(({ icon, label, value }) =>
              value ? (
                <div key={label} style={s.infoRow}>
                  <span style={s.infoIcon}>{icon}</span>
                  <div>
                    <p style={s.infoLabel}>{label}</p>
                    <p style={s.infoValue}>{value}</p>
                  </div>
                </div>
              ) : null
            )}
          </div>

          {/* CTA */}
          {sucursal.ubicacion && (
            <a
              href={sucursal.ubicacion}
              target="_blank"
              rel="noopener noreferrer"
              style={s.cta}
              onMouseEnter={e => e.currentTarget.style.opacity = "0.88"}
              onMouseLeave={e => e.currentTarget.style.opacity = "1"}
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
                <circle cx="12" cy="10" r="3"/>
              </svg>
              Ver en Google Maps
            </a>
          )}
        </div>

      </div>
    </div>
  );
};

const s = {
  overlay: {
    position: "fixed", inset: 0, zIndex: 1300,
    background: "rgba(0,0,0,0.55)",
    display: "flex", alignItems: "center", justifyContent: "center",
    padding: "16px",
    backdropFilter: "blur(4px)",
    animation: "fadeIn 0.18s ease",
  },
  card: {
    background: "#fff",
    borderRadius: "20px",
    width: "100%", maxWidth: "420px",
    overflow: "hidden",
    boxShadow: "0 25px 50px -12px rgba(0,0,0,0.3)",
    animation: "slideUp 0.22s ease",
    position: "relative",
  },
  closeBtn: {
    position: "absolute", top: "12px", right: "12px", zIndex: 10,
    width: "32px", height: "32px", borderRadius: "50%",
    border: "none", background: "rgba(0,0,0,0.45)",
    color: "#fff", fontSize: "20px", lineHeight: 1,
    cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center",
    transition: "background 0.15s",
  },
  media: {
    width: "100%", height: "200px",
    background: "#f3f4f6", overflow: "hidden",
    flexShrink: 0,
  },
  body: {
    padding: "20px 22px 22px",
  },
  chip: {
    display: "inline-block",
    fontSize: "11px", fontWeight: 600,
    textTransform: "uppercase", letterSpacing: "0.07em",
    color: "#185FA5", background: "#E6F1FB",
    borderRadius: "20px", padding: "3px 10px",
    marginBottom: "8px",
  },
  title: {
    fontSize: "20px", fontWeight: 700,
    color: "#111827", margin: "0 0 16px",
    lineHeight: 1.25,
  },
  infoGrid: {
    display: "flex", flexDirection: "column", gap: "12px",
    marginBottom: "20px",
  },
  infoRow: {
    display: "flex", alignItems: "flex-start", gap: "10px",
  },
  infoIcon: {
    fontSize: "16px", lineHeight: 1.4, flexShrink: 0,
  },
  infoLabel: {
    fontSize: "11px", fontWeight: 600, textTransform: "uppercase",
    letterSpacing: "0.05em", color: "#6B7280", margin: "0 0 1px",
  },
  infoValue: {
    fontSize: "14px", color: "#111827", margin: 0, lineHeight: 1.4,
  },
  cta: {
    display: "flex", alignItems: "center", justifyContent: "center", gap: "8px",
    width: "100%", padding: "11px",
    background: "#1a73e8", color: "#fff",
    borderRadius: "10px", textDecoration: "none",
    fontSize: "14px", fontWeight: 600,
    transition: "opacity 0.15s",
    boxSizing: "border-box",
  },
};

export default SucursalModal;